import ICON__chevron_down_solid from '@/assets/icons/font_awesome/chevron-down-solid.svg?react';
import ICON__chevron_up_solid from '@/assets/icons/font_awesome/chevron-up-solid-full.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';

interface PROPS {
  invocation: INVOCATION__base;
}

export function G_BUTTON__node_show_hidden_fields({ invocation }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled, global__is_shift_pressed } = use_slice_ui(['g_general__ui_disabled', 'global__is_shift_pressed']);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent<HTMLButtonElement>) {
    let graph_new = generation_current.tool.graph.clone();

    invocation = graph_new.node__get(invocation.meta.node_id);

    let nodes_to_update = global__is_shift_pressed ? Array.from(graph_new.nodes__get_all().values()) : [invocation];

    let need_show = !invocation.meta.show_hidden_fields;

    for (let node of nodes_to_update) {
      node.meta.show_hidden_fields = need_show;
    }

    await UTILS__graph_data.update(graph_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__button size="square-5" variant={'no-border-on-component'} disabled={is_disabled()} {...{ onClick }}>
      {invocation.meta.show_hidden_fields ? <ICON__chevron_up_solid className="size-4" /> : <ICON__chevron_down_solid className="size-4" />}
    </UI_PRIMITIVE__button>
  );
}
